import { Link, useLocation, useNavigate } from 'react-router-dom'
import { useState } from 'react'
import { useTheme } from '../context/ThemeContext'

const navItems = [
  { href: '/overview', label: 'Overview', color: '#64748b' },
  { href: '/schedule', label: 'Schedule', color: '#f59e0b' },
  { href: '/shows', label: 'Shows', color: '#9333ea' },
  { href: '/music', label: 'Music', color: '#06b6d4' },
  { href: '/commerce', label: 'Fashion / Commerce', color: '#ec4899', hidden: true },
  { href: '/finance', label: 'Finance', color: '#10b981' },
  { href: '/tour-manager', label: 'Tour Manager', color: '#f97316', hidden: true },
  { href: '/tasks', label: 'Tasks', color: '#3b82f6' },
  { href: '/chat', label: 'Chat', color: '#6366f1' },
  { href: '/people', label: 'People / Access', color: '#8b5cf6' },
  { href: '/settings', label: 'Settings', color: '#64748b' },
]

// Sidebar icons (restored)
const navIcons: Record<string, JSX.Element> = {
  '/overview': (
    <svg width="18" height="18" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l9-9 9 9v9a2 2 0 01-2 2h-4a2 2 0 01-2-2V12H11v8a2 2 0 01-2 2H5a2 2 0 01-2-2v-9z" />
    </svg>
  ),
  '/schedule': (
    <svg width="18" height="18" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3M5 11h14M6 21h12a2 2 0 002-2V7a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 16h6" />
    </svg>
  ),
  '/shows': (
    <svg width="18" height="18" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3M5 11h14M6 21h12a2 2 0 002-2V7a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
    </svg>
  ),
  '/music': (
    <svg width="18" height="18" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 18V5l12-2v13" />
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 18a3 3 0 11-6 0 3 3 0 016 0zm12-2a3 3 0 11-6 0 3 3 0 016 0z" />
    </svg>
  ),
  '/commerce': (
    <svg width="18" height="18" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 8h14l-1 13H6L5 8z" />
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 8a3 3 0 016 0" />
    </svg>
  ),
  '/finance': (
    <svg width="18" height="18" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v12m0 0c2.5 0 4.5-1.12 4.5-2.5S14.5 13 12 13s-4.5-1.12-4.5-2.5S9.5 8 12 8m0 10v1m0-14V5" />
    </svg>
  ),
  '/tour-manager': (
    <svg width="18" height="18" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 20l-5.447-2.724A2 2 0 013 15.382V6.618a2 2 0 011.553-1.894L9 3m0 17l6-3m-6 3V3m6 14l5.447 2.724A2 2 0 0021 17.382V8.618a2 2 0 00-1.553-1.894L15 5m0 12V5m0 0L9 3" />
    </svg>
  ),
  '/tasks': (
    <svg width="18" height="18" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4" />
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 7h10M7 17h10" />
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 5h14v14H5V5z" />
    </svg>
  ),
  '/chat': (
    <svg width="18" height="18" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 10h8M8 14h6" />
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a8 8 0 01-8 8H7l-4 3V12a8 8 0 018-8h2a8 8 0 018 8z" />
    </svg>
  ),
  '/people': (
    <svg width="18" height="18" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-1a4 4 0 00-4-4h-1m-4 5H3v-1a4 4 0 014-4h1" />
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 7a4 4 0 11-8 0 4 4 0 018 0z" />
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 11a3 3 0 10-6 0" />
    </svg>
  ),
  '/settings': (
    <svg width="18" height="18" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35A1.724 1.724 0 005.682 8.93c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.573-1.065z" />
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
    </svg>
  ),
}

interface SidebarProps {
  isCollapsed: boolean
  onToggleCollapse: () => void
}

export default function Sidebar({ isCollapsed, onToggleCollapse }: SidebarProps) {
  const location = useLocation()
  const [isOpen, setIsOpen] = useState(false)
  const { theme, toggleTheme } = useTheme()
  const navigate = useNavigate()
  const [user, setUser] = useState<any | null>(() => {
    try {
      const raw = localStorage.getItem('dizeeUser')
      return raw ? JSON.parse(raw) : null
    } catch {
      return null
    }
  })

  const getInitials = (name: string) => {
    const parts = name.trim().split(/\s+/).filter(Boolean)
    if (!parts.length) return 'U'
    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase()
    return `${parts[0][0]}${parts[1][0]}`.toUpperCase()
  }

  const displayName =
    user?.name ||
    user?.username ||
    user?.email ||
    'Account'
  const avatarUrl = user?.avatar || user?.photo || user?.profile_image || null

  const handleLogout = () => {
    localStorage.removeItem('dizeeToken')
    localStorage.removeItem('dizeeUser')
    localStorage.removeItem('selectedArtist')
    localStorage.removeItem('isNewSignup')
    setUser(null)
    setIsOpen(false)
    navigate('/login')
  }

  return (
    <>
      {/* Mobile menu button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="fixed top-4 left-4 z-50 md:hidden p-2 text-sm"
      >
        {isOpen ? 'Close' : 'Menu'}
      </button>

      {/* Sidebar */}
      <aside
        className={`
          fixed
          top-0 left-0
          h-screen
          ${isCollapsed ? 'w-20 overflow-visible' : 'w-72'}
          bg-white sidebar-shell
          z-40
          transform transition-all duration-200 ease-in-out
          ${isOpen ? 'translate-x-0' : '-translate-x-full md:translate-x-0'}
        `}
      >
        <div className="h-full flex flex-col">
          {/* Top section with logo and nav */}
          <div className="flex-1 min-h-0 overflow-y-auto">
            <nav className="p-6">
              <div className="mb-8 flex items-center justify-between">
                {!isCollapsed ? (
                  <>
                    <img src="/favicon.png" alt="DIZEE" className="w-8 h-8" />
                    <button
                      onClick={onToggleCollapse}
                      className="ml-auto p-1 hover:bg-gray-100 rounded transition-colors"
                      aria-label="Minimize sidebar"
                    >
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                      </svg>
                    </button>
                  </>
                ) : (
                  <button
                    onClick={onToggleCollapse}
                    className="mx-auto p-1 hover:bg-gray-100 rounded transition-colors"
                    aria-label="Expand sidebar"
                  >
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </button>
                )}
              </div>
              <ul className="space-y-1">
                {navItems.filter((item) => !('hidden' in item && item.hidden)).map((item) => {
                  const isActive = location.pathname === item.href
                  return (
                    <li key={item.href}>
                      <Link
                        to={item.href}
                        onClick={() => setIsOpen(false)}
                        className={`
                          sidebar-tooltip-wrap
                          relative
                          ${isCollapsed ? 'flex items-center justify-center' : 'block'}
                          py-2
                          ${isCollapsed ? 'px-2' : 'px-2'}
                          text-sm
                          rounded-md
                          transition-colors
                          ${isActive 
                            ? 'text-black font-medium bg-gray-50 active-nav' 
                            : 'text-gray-600 hover:text-black hover:bg-gray-50/50'
                          }
                        `}
                        title={isCollapsed ? item.label : undefined}
                      >
                        {isCollapsed ? (
                          <>
                            <span className="flex items-center justify-center" aria-label={item.label}>
                              {navIcons[item.href] ?? <span className="text-xs font-medium">{item.label.charAt(0)}</span>}
                            </span>
                            <span className="sidebar-tooltip">{item.label}</span>
                          </>
                        ) : (
                          item.label
                        )}
                      </Link>
                    </li>
                  )
                })}
              </ul>
            </nav>
          </div>
          
          {/* Profile + actions fixed at bottom */}
          <div className="flex-shrink-0 p-6 pt-3 space-y-3 border-t border-gray-100">
            <div
              className={`flex items-center ${isCollapsed ? 'justify-center' : 'gap-3 px-2'} py-2`}
              title={isCollapsed ? displayName : undefined}
            >
              {avatarUrl ? (
                <img
                  src={avatarUrl}
                  alt={displayName}
                  className="h-9 w-9 rounded-full object-cover border border-gray-200"
                />
              ) : (
                <div className="h-9 w-9 rounded-full bg-gray-100 text-gray-600 text-xs font-semibold flex items-center justify-center border border-gray-200">
                  {getInitials(String(displayName))}
                </div>
              )}
              {!isCollapsed ? (
                <div className="min-w-0">
                  <div className="text-sm font-medium text-gray-900 truncate">{displayName}</div>
                  <div className="text-xs text-gray-500 truncate">{user?.email || 'Signed in'}</div>
                </div>
              ) : null}
            </div>

            <button
              onClick={handleLogout}
              className={`
                sidebar-theme-toggle
                w-full p-2 rounded-md transition-colors
                ${isCollapsed ? 'flex justify-center' : 'flex items-center gap-2'}
                hover:bg-gray-100
                text-gray-600
              `}
              aria-label="Log out"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a2 2 0 01-2 2H5a2 2 0 01-2-2V7a2 2 0 012-2h6a2 2 0 012 2v1" />
              </svg>
              {!isCollapsed && <span className="text-sm">Log out</span>}
            </button>

            {/* Theme toggle */}
            <button
              onClick={toggleTheme}
              className={`
                sidebar-theme-toggle
                w-full p-2 rounded-md transition-colors
                ${isCollapsed ? 'flex justify-center' : 'flex items-center gap-2'}
                hover:bg-gray-100
                text-gray-600
              `}
              aria-label="Toggle theme"
            >
              {theme === 'light' ? (
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" />
                </svg>
              ) : (
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
                </svg>
              )}
              {!isCollapsed && (
                <span className="text-sm">{theme === 'light' ? 'Dark Mode' : 'Light Mode'}</span>
              )}
            </button>
          </div>
        </div>
      </aside>

      {/* Overlay for mobile */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-10 z-30 md:hidden"
          onClick={() => setIsOpen(false)}
        />
      )}
    </>
  )
}
